var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wm-button-group',{attrs:{"buttons":_vm.buttons},on:{"click":_vm.menuItemClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }